module.exports = __webpack_public_path__ + "media/images/emblems/Gy-coat_of_arms-5966fd791a2cef93dcaf295e0900fedd.svg";